import React, { useState } from "react";
import PageHeader from "../../../Components/PageHeader";
import SearchSelect from "../../../Components/SearchSelect";
import InnerText from "../../../UI/InnerText";
import "../../../Styles/Users.css";
import CommonPercentageInput from "../../../UI/CommonPercentageInput";

const InstructorSettings = () => {
  const [percentage, setPercentage] = useState(null);
  const allowPublicInsturctor = [
    { value: "yes", label: "Yes" },
    { value: "no", label: "No" },
  ];
  return (
    <div>
      <div className="d-flex gap-3 px-3">
        <div className="mt-5 pt-5 d-flex flex-column gap-4 w-100">
          <PageHeader title={"Instructor Settings"} />
          <div className="settings-page">
            <div className="settings-page-left">
              <h6>Public Instructor Settings</h6>
              <SearchSelect
                treeData={allowPublicInsturctor}
                label={"Allow public instructor"}
              />
              <InnerText
                label={"Instructor application note"}
                placeholder={
                  "Fill all the fields carefully and share if you want to share any document with us it will help us to evaluate you as an instructor."
                }
              />
              <div className="flex_center">
                <button className="update_settings_btn">Update Settings</button>
              </div>
            </div>
            <div className="settings-page-right">
              <h6>Instructor commission settings</h6>
              <div>
                <span>Instructor revenue percentage</span>
                <div>
                  <CommonPercentageInput
                    value={percentage}
                    onChange={setPercentage}
                  />
                </div>
              </div>
              <div>
                <span>Admin revenue percentage</span>
                <div>
                  <CommonPercentageInput
                    value={percentage}
                    onChange={setPercentage}
                  />
                </div>
              </div>
              <div className="flex_center">
                <button className="update_settings_btn">Update Settings</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default InstructorSettings;
